import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { useClientAuth } from '@/context/ClientAuthContext';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ClientLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login: clientLogin, isAuthenticated: clientAuth, loading: clientLoading } = useClientAuth();
  const { login: adminLogin, isAuthenticated: adminAuth, loading: adminLoading } = useAuth();
  const navigate = useNavigate();

  // If already authenticated, redirect
  useEffect(() => {
    if (!clientLoading && !adminLoading) {
      if (adminAuth) {
        navigate('/admin', { replace: true });
      } else if (clientAuth) {
        navigate('/', { replace: true });
      }
    }
  }, [clientAuth, adminAuth, clientLoading, adminLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Prova login admin via API
    const adminResult = await adminLogin(email, password);
    if (adminResult.success) {
      toast.success('Accesso Admin effettuato con successo!');
      navigate('/admin');
      setLoading(false);
      return;
    }
    
    // Altrimenti prova login come cliente
    const result = await clientLogin(email, password);
    
    if (result.success) {
      toast.success('Accesso effettuato con successo!');
      navigate('/');
    } else {
      toast.error(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="w-full max-w-md card-elegant">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <img src="/logo-header.png" alt="Capelli&Capelli - Sala Maschile di Evian Ruta" className="h-32 w-32 rounded-xl object-contain" data-testid="auth-logo" />
          </div>
          <CardTitle className="sr-only">Capelli&Capelli - Sala Maschile di Evian Ruta</CardTitle>
          <p className="text-muted-foreground mt-2">Accedi al tuo account</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="mario.rossi@email.com"
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-accent text-accent-foreground hover:bg-accent/90"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Accesso...
                </>
              ) : (
                'Accedi'
              )}
            </Button>
            <div className="text-center text-sm text-muted-foreground">
              Non hai un account?{' '}
              <Link to="/register" className="text-accent hover:underline font-semibold">
                Registrati
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ClientLogin;
